@if (game(); as g) {
<div class="modal fade show d-block" id="gameDetailsModal" tabindex="-1" role="dialog" aria-labelledby="gameDetailsModalLabel" aria-hidden="true" style="background: rgba(0,0,0,0.8); backdrop-filter: blur(12px);" (click)="close()">
  <div class="modal-dialog modal-dialog-centered modal-lg" (click)="$event.stopPropagation()">
    <div class="modal-content details-panel d-flex flex-column flex-md-row bg-dark rounded shadow-lg overflow-hidden border border-secondary">
      <!-- Close Button -->
      <button type="button" class="btn-close btn-close-white position-absolute top-0 end-0 m-3 z-3"
        (click)="close()" aria-label="Close"></button>

      <!-- Left Column: Game Cover art -->
      <div class="details-cover-wrapper flex-shrink-0 position-relative">
        <img [src]="g.coverUrl" class="w-100 h-100 object-fit-cover" [class.grayscale-cover]="!g.installed" [alt]="g.title">
        <div class="cover-gradient-overlay position-absolute bottom-0 start-0 w-100 h-25"></div>
      </div>

      <!-- Right Column: Game Metadata & Actions -->
      <div class="details-info-wrapper flex-grow-1 p-4 d-flex flex-column justify-content-between">
        <div>
          <div class="d-flex align-items-center gap-2 mb-2">
            <span class="badge bg-primary-sub text-primary border border-primary-sub px-2 py-1 rounded small-badge">{{
              g.genre }}</span>
            <span class="text-muted small">{{ g.releaseYear }}</span>
          </div>
          <h3 class="fw-bold text-white mb-3">{{ g.title }}</h3>

          <div class="grid-metadata d-grid gap-3 mb-4">
            <div class="meta-item">
              <span class="text-secondary small d-block">Developer</span>
              <span class="fw-medium text-light">{{ g.developer }}</span>
            </div>
            <div class="meta-item">
              <span class="text-secondary small d-block">Storage Size</span>
              <span class="fw-medium text-light">{{ g.sizeGb }} GB</span>
            </div>
            <div class="meta-item">
              <span class="text-secondary small d-block">Last Played</span>
              <span class="fw-medium text-light">{{ g.lastPlayed }}</span>
            </div>
            <div class="meta-item">
              <span class="text-secondary small d-block">Platforms</span>
              <div class="d-flex gap-1.5 flex-wrap mt-1">
                @for (platform of g.platforms; track platform) {
                <span class="badge bg-secondary rounded-pill small-badge text-light">{{ platform }}</span>
                }
              </div>
            </div>
          </div>

          <p class="text-secondary-sub small-body-text mb-3">
            Experience {{ g.title }} from {{ g.developer }}. Set your installation directory to launch matches and play online servers directly from RivalForge.
          </p>
        </div>

        <!-- Bottom Actions & Game Configuration -->
        <div class="d-flex flex-column gap-3 my-3">
          <!-- Install Path Input Group -->
          <div class="input-group">
            <input #pathInput type="text"
              class="form-control bg-black border-secondary text-white font-monospace small"
              [value]="g.customInstallPath || ''"
              placeholder="Installed in default location or enter path..."
              (change)="updateGamePath(pathInput.value)"
              (keyup.enter)="updateGamePath(pathInput.value)">
            <button class="btn btn-outline-secondary text-nowrap px-3" type="button" (click)="browseGamePath($event)"
              title="Update Game Location">
              <i class="bi bi-folder2-open me-1"></i> Change Path
            </button>
          </div>

          <!-- Executable Input -->
          <div>
            <input #exeInput type="text"
              class="form-control bg-black border-secondary text-white font-monospace small"
              [value]="g.customExecutable || g.executable || ''"
              placeholder="Executable binary (e.g. quake2.exe)..."
              (change)="updateGameExecutable(exeInput.value)"
              (keyup.enter)="updateGameExecutable(exeInput.value)">
          </div>

          <!-- Main Action Button -->
          <div class="d-flex align-items-center gap-3 mt-3 mb-1">
            @if (g.installed) {
            <button
              class="btn btn-play-large w-100 d-flex align-items-center justify-content-center gap-2 py-2.5 rounded shadow"
              (click)="playLaunchGame($event)">
              <i class="bi bi-play-fill fs-4"></i>
              <span class="fw-bold">PLAY</span>
            </button>
            } @else {
            <button
              class="btn btn-download-large w-100 d-flex align-items-center justify-content-center gap-2 py-2.5 rounded shadow"
              (click)="browseGamePath($event)">
              <i class="bi bi-folder2-open fs-5"></i>
              <span class="fw-bold">SET GAME PATH</span>
            </button>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
}